import React, { useEffect, useState } from 'react';
import { env } from '../../../env';
import { PrefetchSelect } from '../../profile-modal/tabs/profile-tab-form';
import { sleep } from '../agency-settings/agency-settings';

const SettingPermissions = () => {
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  async function fetch() {
    try {
      setError(false);
      const { data } = await env.http.get(`permission/${selectedGroup}`);
      setData(data);
    } catch (e) {
      setError(true);
      console.error(e);
    } finally {
      setLoading(false);
    }
  }

  useEffect(
    () => {
      if (!selectedGroup) {
        return;
      }

      fetch();
    },
    [selectedGroup]
  );

  async function onChange(section, type) {
    setLoading(true);

    try {
      await sleep(500);
      await env.http.post(`permission/edit/${selectedGroup}/${section}/${type}/`);
      await fetch();
    } catch (e) {
      setError(true);
      console.error(e);
    } finally {
      setLoading(false);
    }
  }

  if (error) {
    return 'Неудалось загрузить данние';
  }

  const sections = data ? Object.keys(data) : [];

  const body = sections.map(section => {
    return (
      <tr key={section}>
        <td style={{ width: '130px' }}>{section}</td>

        <td style={{ width: '80px' }}>
          <input
            type="checkbox"
            disabled={loading}
            checked={data[section].can_view}
            onChange={() => {
              onChange(section, 'can_view');
            }}
          />
        </td>

        <td style={{ width: '80px' }}>
          <input
            type="checkbox"
            disabled={loading}
            checked={data[section].can_edit}
            onChange={() => {
              onChange(section, 'can_edit');
            }}
          />
        </td>
        <td style={{ width: '80px' }}>
          <input
            type="checkbox"
            disabled={loading}
            checked={data[section].can_create}
            onChange={() => {
              onChange(section, 'can_create');
            }}
          />
        </td>
      </tr>
    );
  });

  return (
    <>
      <div className="account-info__left">
        <ul className="account-info__list">
          <li className="account-info__item">
            <div className="account-info__name">Группа</div>
            <PrefetchSelect
              isSearchable={false}
              editMode={true}
              type="groups"
              selectFirstAndFire
              clearable={false}
              current={null}
              onChange={value => {
                setSelectedGroup(value);
                // setMappedData(data[value]);
              }}
            />
          </li>
        </ul>
      </div>

      <div className="table-container" style={{ display: 'flex', width: '100%', paddingLeft: 0 }}>
        <div className="table-container__body">
          <table className="table" style={{ tableLayout: 'fixed' }}>
            <thead>
              <tr>
                <th style={{ width: '130px' }} />
                <th style={{ width: '80px' }}>Can view</th>
                <th style={{ width: '80px' }}>Can edit</th>
                <th style={{ width: '80px' }}>Can create</th>
              </tr>
            </thead>
            <tbody>{body}</tbody>
          </table>
        </div>
      </div>
    </>
  );
}

export default SettingPermissions;